import LikeButton from "./Likebutton";
import LikeCounter from "./Likecount";


const CommentItem = ({ comment, isReply = false, onLike, isLiked }) => (
  <div
    className={`flex gap-4 ${
      isReply ? "ml-12 mt-1" : "mt-2"
    } bg-white rounded-lg p-3 relative`}
  >
    <img
      src={comment.avatar}
      alt={`${comment.name}'s avatar`}
      className="w-10 h-10 rounded-full object-cover"
    />
    <div className="flex-1">
      <div className="bg-[#F0F2F5] rounded-lg p-3 shadow-sm">
        <p className="font-semibold text-[#385898] text-sm hover:underline cursor-pointer">
          {comment.name}
        </p>
        <p className="text-[15px] mt-1 text-gray-800">{comment.text}</p>
      </div>
      <div className="flex items-center gap-3 mt-1 text-[13px] text-[#65676B]">
        <LikeButton isLiked={isLiked} onClick={() => onLike(comment.id)} />
        <button className="font-semibold hover:underline">Reply</button>
        <span className="text-[#65676B]">
          {/* {formatDistanceToNow(comment.time, { addSuffix: true })} */}
          {comment.time}
        </span>
      </div>
    </div>
    <div className="flex items-center gap-1 absolute right-4 bottom-5">
      <LikeCounter count={comment.likes + (isLiked ? 1 : 0)} />
    </div>
  </div>
);

export default CommentItem;
